export { numberFormatters } from "./number.formatters"
export { formatDate } from "./date.formatters"  

export const capitalized = (string: String): string => string.charAt(0).toLocaleUpperCase() + string.slice(1)
